import { render, staticRenderFns } from "./InvoiceAcceptModal.vue?vue&type=template&id=08d45e02&scoped=true&"
import script from "./InvoiceAcceptModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceAcceptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d45e02",
  null
  
)

export default component.exports